// Meta / Instagram settings API client (2026-08-03)
// 路径:/api/v1/settings/meta/*
// 不持有 token;backend 已加密保存 + 脱敏输出。

import { apiFetch } from "./client";

export type MetaConnection = {
  id: string;
  tenant_id: string;
  status: string;
  provider: string;
  auth_mode: string;
  facebook_user_id?: string | null;
  business_id?: string | null;
  business_name?: string | null;
  page_id?: string | null;
  page_name?: string | null;
  instagram_account_id?: string | null;
  instagram_username?: string | null;
  user_token_hint?: string | null;
  user_token_expires_at?: string | null;
  page_token_hint?: string | null;
  page_token_expires_at?: string | null;
  granted_scopes?: string[] | null;
  last_verified_at?: string | null;
  last_sync_at?: string | null;
  last_error_code?: string | null;
  last_error_message?: string | null;
  disconnect_reason?: string | null;
  source?: string | null;
  connected_at?: string | null;
  updated_at?: string | null;
  is_active?: boolean;
};

export type MetaSettingsResponse = {
  ok: boolean;
  configured: boolean;
  graph_version: string;
  app_id_hint: string | null;
  connections: MetaConnection[];
  active_connection_id: string | null;
};

export type MetaCandidatesResponse = {
  ok: boolean;
  candidates: Array<{
    business_id: string;
    business_name: string;
    page_id: string;
    page_name: string;
    instagram_account_id: string;
    instagram_username: string;
    source: string;
  }>;
  select_token: string;
};

export const metaSettingsApi = {
  async getSettings(): Promise<MetaSettingsResponse> {
    return apiFetch<MetaSettingsResponse>("/v1/settings/meta");
  },

  async getCandidates(token: string): Promise<MetaCandidatesResponse> {
    const qs = new URLSearchParams({ token });
    return apiFetch<MetaCandidatesResponse>(
      `/v1/settings/meta/candidates?${qs.toString()}`
    );
  },

  async selectAccount(payload: {
    select_token: string;
    page_id: string;
    instagram_account_id: string;
  }): Promise<{ ok: boolean; connection: MetaConnection }> {
    return apiFetch("/v1/settings/meta/select-account", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  async reconnect(): Promise<never> {
    // backend 直接 302 — 前端不需要 await fetch
    window.location.href = "/api/v1/settings/meta/reconnect?next=/settings";
    return null as never;
  },

  async testConnection(
    connection_id: string
  ): Promise<{ ok: boolean; connection: MetaConnection; verified: boolean }> {
    return apiFetch("/v1/settings/meta/test", {
      method: "POST",
      body: JSON.stringify({ connection_id }),
    });
  },

  async disconnect(connection_id: string): Promise<{ ok: boolean }> {
    return apiFetch(`/v1/settings/meta/connection/${connection_id}`, {
      method: "DELETE",
    });
  },

  async purgeLocalData(
    connection_id: string,
  ): Promise<{
    ok: boolean;
    status: "purged";
    connection_id: string;
    deleted_counts: Record<string, number>;
  }> {
    return apiFetch(`/v1/settings/meta/connection/${connection_id}/purge`, {
      method: "DELETE",
    });
  },
};
